import React, { useState } from 'react';
import { Progress } from '@logora/parliament.ui.progress';
import styles from './StatBox.module.scss';

interface StatBoxProps {
    /** Main icon */
    icon: React.ReactNode;
    /** Highlighted statistic to display */
    mainStat: any;
    /** text accompanying the statistic */
    text: string;
    /** Extra classname */
    className?: string;
    /** Second statistic to display */
    maxValue?: any;
    /** Average value */
    average?: any;
    /** Color to pass to progress */
    color?: string;
}

export const StatBox = ({ icon, mainStat, text, className, maxValue, average, color = "#434343" }: StatBoxProps) => {
    const calculatePercentage = (value: number, end: number) => {
        const percentage = (value / end) * 100;
        return percentage;
    };

    const markerPositionValue = average !== undefined 
        ? calculatePercentage(average, maxValue) 
        : null;

    return (
        <div className={`${className} ${styles.statBoxContainer}`}>
            <span className={styles.icon}>{ icon && icon }</span>
            <div className={styles.statBoxContent}>
                <span className={styles.mainStat}>{ mainStat }</span>
                { text }
                { average && maxValue &&
                    <>
                        <span className={styles.averageMarker} style={{ left: `${markerPositionValue}%`, backgroundColor: color }}>
                            Moyenne {average}
                            <span className={styles.averagePointer} style={{ borderTopColor: color }}></span>
                        </span>
                        <div className={styles.progressContainer}>
                            <Progress mainNumber={parseInt(mainStat)} endValue={parseInt(maxValue)} markerValue={parseInt(average)} color={color} />
                        </div>
                        <div className={styles.progressMax}>
                            <span>0</span>
                            <span>{maxValue}</span>
                        </div>
                    </>
                }
            </div>
        </div>
    );
};